import { atomFamily } from "recoil";
import { UnlockLocksOfBookingResponse } from "use-smart-locks-shared";
import { preferencesEffect } from "./preferences.effect";

/**
 * Stores the unlock result which contains the mapping of unit ids to their bluetooth device authentication data.
 * The primary use case is to be able to unlock bluetooth locks without having an internet connection (https://linear.app/brainchimps/issue/BRA-112).
 */
export const unlockLocksOfBookingResponseState = atomFamily<
  UnlockLocksOfBookingResponse | null,
  string // BookingId
>({
  key: "unlockLocksOfBookingResponse",
  default: null,
  effects: [preferencesEffect<UnlockLocksOfBookingResponse | null>({})],
});
